export const tPath = 'dvrPage.';
